import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const CustomField1 = {
  id: 'customField1',
  displayName: <FormattedMessage {...messages.customField1} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'CustomField1',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
